import PropTypes from 'prop-types';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { inkA } from '../tokens';

// Gen-3 pill switch — orange when on. Sizes: md (46x26) and sm (40x22).
// tone="success" (opt-in) turns it the design's success green when on, for
// Live / Draft status switches.

// The design's --success (colors_and_type.css). v3 tokens have no success
// colour yet; move this there if one is added.
const ON_COLORS = { brand: '#fa4616', success: 'rgb(34, 197, 94)' };

const Track = styled.button`
  position: relative;
  width: ${({ w }) => w}px;
  height: ${({ h }) => h}px;
  flex-shrink: 0;
  border-radius: ${({ h }) => h}px;
  border: none;
  cursor: pointer;
  padding: 0;
  background: ${({ on, $onBg, offBg }) => (on ? $onBg : offBg)};
  transition: background 160ms ease;
`;

const Knob = styled.span`
  position: absolute;
  top: 3px;
  left: ${({ on, w, k }) => (on ? w - k - 3 : 3)}px;
  width: ${({ k }) => k}px;
  height: ${({ k }) => k}px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: left 160ms cubic-bezier(0.2, 0.8, 0.2, 1);
`;

const ToggleSwitch = ({ on, onClick, size = 'md', label, tone = 'brand' }) => {
  const theme = useTheme();
  const w = size === 'sm' ? 40 : 46;
  const h = size === 'sm' ? 22 : 26;
  const k = h - 6;
  return (
    <Track
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      onClick={onClick}
      on={on ? 1 : 0}
      w={w}
      h={h}
      $onBg={ON_COLORS[tone] || ON_COLORS.brand}
      offBg={inkA(theme, 0.18)}
    >
      <Knob on={on ? 1 : 0} w={w} k={k} />
    </Track>
  );
};

ToggleSwitch.propTypes = {
  on: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md']),
  label: PropTypes.string,
  tone: PropTypes.oneOf(['brand', 'success']),
};

export default ToggleSwitch;
